import fetch from 'isomorphic-fetch';

const defaultHeaders = {
  'Content-Type': 'application/json',
};

// Handle HTTP errors because fetch won't
const handleAPIError = ({statusText}) => {
  const message = statusText || 'Unknown error';
  throw Error(message);
};

const handleAPIResponse = response => {
  // write all Error handling , logging code here
  if (!response.ok) {
    handleAPIError(response);
  }
  return response.json();
};

// Fetch/GET data from API
export const getAPI = (url, headers) =>
  fetch(`${url}`, {
    method: 'GET',
    headers: {
      ...defaultHeaders,
      ...headers
    },
  })
    .then(handleAPIResponse)
    .catch(handleAPIError);
